var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNedgia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "35px",
    viewBox: "0 0 34 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000197462022 0.346357065 18.7648853 0.346357065 18.7648853 31.7604374 0.000197462022 31.7604374"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DSC-+-Responsive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mensaje-post-datos-Mobile-Copy",
    transform: "translate(-20.000000, -23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nedgia-minimal",
    transform: "translate(20.000000, 22.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(0.000000, 0.255017)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1309469,18.8082108 C14.2113436,27.3468746 8.3739422,33.036511 4.09442473,31.513983 C-0.183889277,29.995063 -1.28806736,21.8364299 1.63394288,13.2977662 C4.55655485,4.76090635 10.3921511,-0.92993264 14.6710668,0.59259529 C18.9493808,2.11211665 20.0529572,10.2683445 17.1309469,18.8082108",
    id: "Fill-40",
    fill: "#F5B900",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.9782716,17.3661388 C19.8490302,23.9030271 13.272702,27.6371892 11.2911988,25.7051662 C9.30608513,23.7683326 12.6649527,16.9031267 18.7929907,10.3644345 C24.9216304,3.82935016 31.501569,0.0951880613 33.4872844,2.03142026 C35.4681859,3.96163932 32.1081148,10.8292505 25.9782716,17.3661388",
    id: "Fill-43",
    fill: "#E83201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7574885,10.4052637 C12.6523164,16.9295244 9.30849206,23.7736843 11.2911988,25.7045047 C11.8014674,26.2035956 12.6258402,26.3220545 13.6692433,26.1103919 C15.0135125,24.1290611 16.2169763,21.737634 17.1310071,19.0629877 C18.168393,16.0341674 18.6961119,13.0564587 18.7574885,10.4052637",
    id: "Fill-45",
    fill: "#171713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8951229,31.5422448 C19.8951229,33.2505789 18.5358105,34.6384124 16.8629957,34.6384124 C15.1829602,34.6384124 13.8242495,33.2505789 13.8242495,31.5422448 C13.8242495,29.8321068 15.1829602,28.4454759 16.8629957,28.4454759 C18.5358105,28.4454759 19.8951229,29.8321068 19.8951229,31.5422448",
    id: "Fill-47",
    fill: "#F5B900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1888442,10.6436849 C11.1888442,11.5432512 10.4781988,12.2714428 9.59605974,12.2714428 C8.71031035,12.2714428 7.99485108,11.5432512 7.99485108,10.6436849 C7.99485108,9.74411862 8.71031035,9.01231906 9.59605974,9.01231906 C10.4781988,9.01231906 11.1888442,9.74411862 11.1888442,10.6436849",
    id: "Fill-49",
    fill: "#171713"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNedgia);
export default __webpack_public_path__ + "static/media/logo_nedgia.6c9e02bce09adafd8e22a03b2f4af094.svg";
export { ForwardRef as ReactComponent };